import { useCallback, useContext } from 'react';
import AlertsContext from '~/context/common/AlertsContext';
import FavoritesToastContent from './FavoritesToastContent';
import styles from './FavoritesToastContent.module.css';
import type { ToastAction, ToastView } from './types';

export default function useDisplayFavoritesToast() {
  const { showToast } = useContext(AlertsContext);

  return useCallback(
    (action: ToastAction, view?: ToastView) =>
      showToast({
        className: styles.favoriteToast,
        label: <FavoritesToastContent action={action} view={view} />,
        lifetime: 6000,
        position: 'top-center',
        severity: 'custom',
        showClose: false
      }),
    [showToast]
  );
}
